import { c as _c } from "react/compiler-runtime";
import { useFetcher } from "@website/fetcher/use-fetcher/use-fetcher";
import { fetchEmptyStates } from "./index.services";
interface Properties {
  dest: string;
  origin: string;
  stDate: string;
  rtDate: string;
  passengers: Array<{
    adultCount: number;
    children: Array<number>;
  }>;
}
export function useEmptyStates(t0) {
  const $ = _c(21);
  const {
    dest,
    origin,
    stDate,
    rtDate,
    passengers
  } = t0;
  let t1;
  if ($[0] !== dest || $[1] !== origin || $[2] !== passengers || $[3] !== rtDate || $[4] !== stDate) {
    t1 = {
      queryKey: ["emptyStates", dest, origin, stDate, rtDate, passengers],
      queryFn: () => fetchEmptyStates(dest, origin, stDate, rtDate, passengers)
    };
    $[0] = dest;
    $[1] = origin;
    $[2] = passengers;
    $[3] = rtDate;
    $[4] = stDate;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const {
    data: emptyStates
  } = useFetcher(t1);
  let t2;
  if ($[6] !== emptyStates) {
    t2 = emptyStates || [];
    $[6] = emptyStates;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== dest || $[9] !== origin || $[10] !== rtDate || $[11] !== stDate || $[12] !== t2) {
    let t4;
    if ($[14] !== dest || $[15] !== origin || $[16] !== rtDate || $[17] !== stDate) {
      t4 = item => !(item.origin === origin && item.destination === dest && item.departureDate === stDate && item.returnDate === rtDate);
      $[14] = dest;
      $[15] = origin;
      $[16] = rtDate;
      $[17] = stDate;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    t3 = t2.filter(t4);
    $[8] = dest;
    $[9] = origin;
    $[10] = rtDate;
    $[11] = stDate;
    $[12] = t2;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const filteredData = t3;
  let t4;
  if ($[19] !== filteredData) {
    t4 = {
      emptyStates: filteredData
    };
    $[19] = filteredData;
    $[20] = t4;
  } else {
    t4 = $[20];
  }
  return t4;
}